import { Skeleton } from "@/ui";

export const InsuranceCardsSkeleton = () => {
  return (
    <>
      <Skeleton className="h-20 rounded-xl" />
      <Skeleton className="h-20 rounded-xl" />
    </>
  );
};
